import React, { useEffect, useState } from 'react';
import { FolderInput, Loader2, X } from 'lucide-react';
import { api } from '../context/AuthContext';

export const MoveMessageDialog = ({ message, onClose, onMoved }) => {
  const mnr = (message.case_id || '').replace('general_', '');
  const [threads, setThreads] = useState(null);
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get(`/cases/mandanten/${mnr}/threads`).then((r) => setThreads(r.data.items || [])).catch((e) => { setThreads([]); setErr(e?.response?.data?.detail || 'Akten konnten nicht geladen werden'); });
  }, [mnr]);

  const move = async (t) => {
    setBusy(t.case_id); setErr('');
    try { await api.post(`/cases/${message.case_id}/messages/${message.id}/move`, { target_case_id: t.case_id }); onMoved(t); }
    catch (e) { setErr(e?.response?.data?.detail || 'Verschieben fehlgeschlagen'); setBusy(''); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="move-message-dialog">
      <div className="bg-white w-full max-w-sm shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#1B3A5C]"><FolderInput className="w-4 h-4 text-[#b8893d]" /> In Akte verschieben</span>
          <button type="button" onClick={onClose} aria-label="Schließen" data-testid="move-message-close"><X className="w-4 h-4 text-[#7a8a99]" /></button>
        </div>
        <p className="px-4 pt-3 text-xs text-[#34536b] line-clamp-2 italic">„{message.text || message.attachment?.filename}“</p>
        {err && <p className="mx-4 mt-2 px-2 py-1 text-xs text-red-700 bg-red-50" data-testid="move-message-error">{err}</p>}
        <div className="p-4 space-y-1.5">
          {threads === null && <div className="flex justify-center py-4"><Loader2 className="w-4 h-4 animate-spin text-[#7a8a99]" /></div>}
          {threads?.length === 0 && !err && <p className="text-xs text-center text-[#7a8a99] py-3">Für diesen Mandanten gibt es noch keine aktive Akte.</p>}
          {threads?.map((t) => (
            <button key={t.case_id} type="button" onClick={() => move(t)} disabled={!!busy} data-testid={`move-target-${t.case_id}`}
              className="w-full flex items-center justify-between gap-2 px-3 py-2 text-left border border-gray-200 hover:border-[#b8893d] hover:bg-[#fbf7f0] transition-colors disabled:opacity-50">
              <span className="font-mono text-xs text-[#1B3A5C]">{t.aktenzeichen ? `AZ ${t.aktenzeichen}` : 'Ohne Aktenzeichen'}</span>
              <span className="text-[11px] text-[#7a8a99]">{busy === t.case_id ? <Loader2 className="w-3 h-3 animate-spin" /> : t.rechtsgebiet}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoveMessageDialog;
